import { FC, useMemo } from "react";
import { routePaths } from "../../../Router/router";
import {
  Button,
  Chip,
  Grid2,
  InputAdornment,
  Link,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router";
import { GridActionsCellItem, GridColDef, GridRenderCellParams, useGridApiRef } from "@mui/x-data-grid-premium";
import TableCellDueDate from "../TableCellDueDate/TableCellDueDate";
import TableCellOrderStatus from "../TableCellOrderStatus/table-cell-order-status";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import WarningIcon from "@mui/icons-material/Warning";
import SecurityIcon from "@mui/icons-material/Security";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import InfoIcon from "@mui/icons-material/Info";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ReplayIcon from "@mui/icons-material/Replay";
import CancelIcon from "@mui/icons-material/Cancel";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import MergeTypeIcon from "@mui/icons-material/MergeType";
import EditIcon from "@mui/icons-material/Edit";
import CachedIcon from "@mui/icons-material/Cached";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SearchIcon from "@mui/icons-material/Search";
import CheckIcon from "@mui/icons-material/Check";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import MemoryIcon from "@mui/icons-material/Memory";
import FlagIcon from "@mui/icons-material/Flag";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import HelpIcon from "@mui/icons-material/Help";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import React from "react";
import { DbOrderItemInfos } from "../../../Core/Api/Types/db-order-item-infos";
import { OrderStatus } from "../../../Core/Api/Types/order-status";
import PageFilter from "../../Misc/PageFilter";
import ListPageHeader, { ListPageHeaderGroupActions, ListPageHeaderRight } from "../../Misc/ListPageHeader";
import { DbCustomerInfos } from "../../../Core/Api/Types/db-customer-infos";
import OrderProductIcon from "../../Misc/OrderProductIcon/order-product-icon";
import TableCellDate2Lines from "../TableCellDate2Lines";
import TableCellStringExpend from "../TableCellStringExpend/table-cell-string-expend";
import TableCellOwner2Lines from "../TableCellOwner2Lines/table-cell-owner-2-lines";
import TableCellOrderPriority from "../TableCellOrderPriority/table-cell-order-priority";
import TableCellOrderObjectInfos from "../TableCellOrderObjectInfos/table-cell-order-object-infos";
import {
  Distinct,
  GetEnumValueLabelMap,
  GetOrderProductReadableType,
  GetOrderStatusLabel,
  UserHasAcl,
} from "../../../Utils/helpers";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import { OrderProductType } from "../../../Core/Api/Types/order-product-type";
import { cacheService, cockpitService, eventsNotifier, orderService, supportService } from "../../../Core/Api/services";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import useBasketActions from "../../../Utils/Hooks/useBasketActions";
import DataTable, { CellSize } from "../table";
import { OrderItemProductNonDoableFlag } from "../../../Core/Api/Types/order-item-product-non-doable-flag";
import ModalOrderManualChanges, {
  ModalOrderManualChangesProps,
} from "../../Modals/ModalOrderManualChanges/modal-order-manual-changes";
import { ModalContext } from "../../Modals";
import ModalSetFollowers, { ModalSetFollowersElementProps } from "../../Modals/ModalSetFollowers/modal-set-followers";
import { produce, immerable } from "immer";
import { EventNotifierOperation } from "../../../Core/Api/notifier-client";
import { GridRowParams } from "@mui/x-data-grid-premium";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import TableCellTypography from "../TableCellTypography/table-cell-typography";
import ModalConfirmAction, {
  ModalConfirmActionElementProps,
} from "../../Modals/ModalConfirmAction/modal-confirm-action";
import TableCellDateTime from "../TableCellDateTime/table-cell-date-time";
import { CancelOrdersByIds } from "../../../Redux/Reducers/redux-slice-object-orders";
import { useDispatch } from "react-redux";
import moment from "moment";
import { PlatformNames } from "../../../Core/Api/Types/platform-names";
import { MakeOperationRequest } from "../../../Core/Api/Types/make-operation-request";
import { ResourceType } from "../../../Core/Api/Types/cockpit-ressource-type";
import { Action } from "../../../Core/Api/Types/cockpit-action";
import PlaceIcon from "@mui/icons-material/Place";
import TableCellActionReportIssue from "../TableCellActionReportIssue/table-cell-action-report-issue";
import { useTranslation } from "react-i18next";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { CheckOutlined, WorkspacesOutlined } from "@mui/icons-material";
import TableUuids from "../table-uuids";
import { CurrencyPriceInfos } from "../../../Core/Api/Types/currency-price-infos";

export enum OrderItemTableContext {
  Normal,
  Quotes,
  Search,
}
interface OrderItemTableProps {
  showPanelOrder?: React.Dispatch<React.SetStateAction<DbOrderItemInfos>>;
  setSelectedItems?: React.Dispatch<React.SetStateAction<DbOrderItemInfos[]>>;
  selectedItems?: DbOrderItemInfos[];
  orders: DbOrderItemInfos[];
  context?: OrderItemTableContext;
  enableWebsocket?: boolean;
  platforms?: PlatformNames[];
  isCockpit?: boolean;
  onFilteredItemCountChange?: (count: number) => void;
  isLoading?: boolean;
}

export enum ItemProcessingMode {
  Auto = "Auto",
  Manual = "Manual",
  ManualExternal = "ManualExternal",
  Hybrid = "Hybrid",
}

const OrderItemTable: FC<OrderItemTableProps> = (props) => {
  const { t } = useTranslation();
  const {
    orders,
    context = OrderItemTableContext.Normal,
    showPanelOrder,
    setSelectedItems,
    selectedItems,
    enableWebsocket = true,
    platforms,
    isCockpit = false,
    onFilteredItemCountChange,
    isLoading,
  } = props;

  const [rows, setDataGrid] = React.useState<DbOrderItemInfos[]>([]);

  // Filters
  const [filterIndexStatuses, setFilterIndexStatus] = React.useState<OrderStatus[]>([]);
  const [filterIndex, setFilterIndex] = React.useState<number>(-1);
  const [filterCustomer, setFilterCustomer] = React.useState<number>(-1);
  const [filterPlatform, setFilterPlatform] = React.useState<number>(-1);
  const [filterStatus, setFilterStatus] = React.useState<string>("");
  const [filterText, setFilterText] = React.useState<string>("");
  const [filterProcessingMode, setFilterProcessingMode] = React.useState<ItemProcessingMode | undefined>(undefined);
  const [filterFlag, setFilterFlag] = React.useState<OrderItemProductNonDoableFlag | undefined>(undefined);
  const [filterType, setFilterType] = React.useState<OrderProductType | undefined>(undefined);
  const [filterUserGroup, setFilterUserGroup] = React.useState<string>("");
  const [filterEditor, setFilterEditor] = React.useState<string>("");
  const [filterWatermark, setFilterWatermark] = React.useState<string>("");
  const [filterWarning, setFilterWarning] = React.useState<string>("");
  const [filterPriority, setFilterPriority] = React.useState<string | undefined>();
  const [customers, setCustomers] = React.useState<DbCustomerInfos[]>([]);

  const apiGrid = useGridApiRef();
  const enqueueCustomSnackbar = useCustomSnackbar();
  const { modifyObjectByIdToBasket, copyObjectByIdToBasket } = useBasketActions();
  const dispatch = useDispatch();

  // Acls
  const aclApprove = UserHasAcl(AclTypes.aclOrderApprove);
  const aclCancel = UserHasAcl(AclTypes.aclOrderCancel);
  const aclStart = UserHasAcl(AclTypes.aclOrderStart);
  const aclModify = UserHasAcl(AclTypes.aclOrderUpdate);
  const aclPriority = UserHasAcl(AclTypes.aclOrderAssignPriority);
  const aclSuperUser = UserHasAcl(AclTypes.aclSuperUser);
  const aclAdmin = UserHasAcl(AclTypes.aclAdmin);
  const aclOrderManualTaskExternalChangeStatus = UserHasAcl(AclTypes.aclOrderManualTaskExternalChangeStatus);
  const aclOrderAssignFollowers = UserHasAcl(AclTypes.aclOrderAssignFollowers);
  const aclQuoteValidate = UserHasAcl(AclTypes.aclOrderQuoteValidate);
  const aclCopy = UserHasAcl(AclTypes.aclSectionOrderAccess);
  const customerName = cacheService.GetCustomerExternalIdLabel();

  // Modals
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };

  // SignalR
  React.useEffect(() => {
    if (enableWebsocket) {
      eventsNotifier.Connect().then(function (result) {
        console.debug("Hub Events Connected successfully to WebSocket and is listening to OrderItemMessage!");
        if (eventsNotifier.connection)
          eventsNotifier.connection.on("OrderItemMessage", (data) => {
            switch (data.op) {
              case EventNotifierOperation.Create:
                // add row to table
                setDataGrid(
                  produce((draft) => {
                    draft.unshift(data.data);
                  })
                );
                break;
              case EventNotifierOperation.Update:
                // update row in table
                setDataGrid(
                  produce((draft) => {
                    const index = draft.findIndex((x) => x.id === data.data.id);
                    if (index !== -1) draft[index] = data.data;
                  })
                );
                break;
              case EventNotifierOperation.Delete:
                // delete row from table
                setDataGrid(
                  produce((draft) => {
                    const index = draft.findIndex((x) => x.id === data.data.id);
                    if (index !== -1) draft.splice(index, 1);
                  })
                );
                break;
            }
          });
      });

      // Disconnect when unmount
      return function cleanup() {
        eventsNotifier.Disconnect().then(function () {});
      };
    }
  }, []);

  const getItemProcessingMode = (item: any): ItemProcessingMode => {
    if ((item.isAutomatedPipeline && !item.manualTasksTemplateId) || item.manualTasksTemplateId === 0)
      return ItemProcessingMode.Auto;
    else {
      if (item.manualTasksTemplate && item.manualTasksTemplate.isTreatedExternally)
        return ItemProcessingMode.ManualExternal;

      return !item.isAutomatedPipeline ? ItemProcessingMode.Manual : ItemProcessingMode.Hybrid;
    }
  };

  type Row = (typeof rows)[number];

  // Cols
  const columns: GridColDef<DbOrderItemInfos>[] = [
    {
      field: "platformId",
      headerName: t("common:platform"),
      minWidth: CellSize.xxsmall,
      flex: CellSize.xxsmall,
      renderCell: (data: GridRenderCellParams<Row>) => (
        <Chip
          size="small"
          color="default"
          label={platforms?.find((x) => x.id === data.value) ? platforms!.find((x) => x.id === data.value)!.name : ""}
        />
      ),
    },
    {
      field: "orderId",
      headerName: t("menu:title.orderId"),
      minWidth: CellSize.xxsmall,
      flex: CellSize.xxsmall,
      renderCell: (data: GridRenderCellParams<Row>) => (
        <Link
          color="primary.text"
          underline="hover"
          component={RouterLink}
          to={`${routePaths.ordersOverview.path}/${data.value}`}
          target="_blank"
        >
          {data.value}
        </Link>
      ),
    },
    {
      field: "id",
      headerName: t("table:headerName.itemId"),
      minWidth: CellSize.xxsmall,
      flex: CellSize.xxsmall,
    },
    {
      field: "titleCustomerId",
      headerName: customerName + " Id",
      minWidth: CellSize.xsmall,
      flex: CellSize.xsmall,
      renderCell: (data: GridRenderCellParams<Row>) => data.value || "-",
    },
    {
      field: "objectName",
      headerName: t("common:object"),
      minWidth: CellSize.xlarge,
      flex: CellSize.xlarge,
      valueFormatter: (value) => `${(value as string)?.replace(/(\r\n|\n|\r)/gm, " ")}`,
      renderCell: (data: GridRenderCellParams<Row>) => (
        <Link
          color="primary.text"
          underline="hover"
          component={RouterLink}
          to={`${data.row.objectLayer === ObjectLayer.Title ? routePaths.title.path : routePaths.asset.path}/${
            data.row.objectLayer === ObjectLayer.Clip ? data.row.parentObjectId : data.row.objectId
          }`}
          sx={(theme) => ({ wordBreak: "break-word" })}
        >
          {data.row.objectName}
        </Link>
      ),
    },
    {
      field: "summary",
      headerName: t("common:summary"),
      minWidth: CellSize.xlarge,
      flex: CellSize.xlarge,
      valueGetter: (data: GridRenderCellParams<Row>, row) => {
        if (!row) return;
        return row.summarizedInfos;
      },
      renderCell: (data: GridRenderCellParams<Row>) => (
        <Stack>
          <Typography
            color="text.secondary"
            variant="body2"
            sx={{ whiteSpace: "normal !important", wordBreak: "break-word" }}
          >
            {data.row.watermarking && (
              <Tooltip title={t("menu:title.watermarkingEnabled")}>
                <SecurityIcon color="success" fontSize="small" sx={{ mr: 0.5 }} />
              </Tooltip>
            )}
            {data.row.summarizedInfos}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "type",
      headerName: t("common:type"),
      minWidth: CellSize.xsmall,
      flex: CellSize.xsmall,
      align: "center",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: GetEnumValueLabelMap(OrderProductType), //[{ value: "Video", label: "Video Label" }],
      renderCell: (data: GridRenderCellParams<Row>) => <OrderProductIcon type={data.value} color="info" />,
    },
    {
      field: "creationTime",
      headerName: t("common:createdAt"),
      type: "date",
      valueGetter: (data: GridRenderCellParams<Row>, row) =>
        row.creationTime === null ? null : new Date(row.creationTime),
      minWidth: CellSize.medium,
      flex: CellSize.medium,
      renderCell: (data: GridRenderCellParams<Row>) =>
        data.row.creationTime ? <TableCellDate2Lines date={data.row.creationTime} /> : null,
    },
    {
      field: "ownerUserName",
      headerName: t("common:owner"),
      minWidth: CellSize.medium,
      flex: CellSize.medium,
      renderCell: (data: GridRenderCellParams<Row>) => (
        <TableCellOwner2Lines
          userName={data.row.ownerUserName ?? ""}
          groupName={data.row.ownerUserGroupName ?? ""}
          ellipsis={false}
        />
      ),
    },
    {
      field: "editorName",
      headerName: t("common:proposedBy"),
      minWidth: CellSize.medium,
      flex: CellSize.medium,
      renderCell: (data: GridRenderCellParams<Row>) => <TableCellTypography data={data.value} />,
    },
    {
      field: "customerName",
      headerName: t("common:customer"),
      minWidth: CellSize.small,
      flex: CellSize.small,
      renderCell: (data: GridRenderCellParams<Row>) => (data.value !== null && data.value !== "" ? data.value : "N/A"),
    },
    {
      field: "price",
      headerName: t("common:price"),
      minWidth: CellSize.small,
      flex: CellSize.small,
      valueGetter: (data: GridRenderCellParams<Row>, row) =>
        row.price && row.status !== OrderStatus.QUOTE_REQUESTED ? row.price : null,
      renderCell: (data: GridRenderCellParams<Row>): string =>
        data.value !== null ? data.value.price + " " + data.value.currency : "N/A",
      valueFormatter: (value: CurrencyPriceInfos | null) =>
        `${value !== null ? value.price + " " + value.currency : "N/A"}`,
    },
    {
      field: "status",
      headerName: t("common:status"),
      align: "center",
      headerAlign: "center",
      minWidth: CellSize.xxsmall,
      flex: CellSize.xxsmall,
      type: "singleSelect",
      valueOptions: GetEnumValueLabelMap(OrderStatus, GetOrderStatusLabel).filter(
        (x) => orders.findIndex((o) => o.status === x.value) >= 0
      ),
      renderCell: (data: GridRenderCellParams<Row>) => <TableCellOrderStatus data={data} hideText />,
    },
    {
      field: "message",
      headerName: t("common:message"),
      minWidth: CellSize.xlarge,
      flex: CellSize.xlarge,
      valueFormatter: (value) => `${(value as string)?.replace(/(\r\n|\n|\r)/gm, " ").substring(0, 250)}`,
      renderCell: (data: GridRenderCellParams<Row>) =>
        data?.row?.status !== "MANUAL_DELIVERY_BEFORE_COMPLETED" ? (
          data?.row?.status === "FAILED" || data?.row?.status === "ABORTED" ? (
            <TableCellStringExpend data={data} />
          ) : (
            <Typography color="text.secondary">{data.value}</Typography>
          )
        ) : (
          t("table:renderCell.manualDeliveryInProgress")
        ),
    },
    {
      field: "priority",
      headerName: t("common:priority"),
      type: "singleSelect",
      valueGetter: (data: GridRenderCellParams<Row>, row) => {
        if (!row) return;
        return getPriority(row?.priority ?? 0);
      },
      valueOptions: ["Normal", "Low", "High", "Urgent"],
      minWidth: CellSize.small,
      flex: CellSize.small,
      renderCell: (data: GridRenderCellParams<Row>) => <TableCellOrderPriority priority={data.row.priority ?? 1} />,
    },
    {
      field: "startTime",
      headerName: t("common:startDateLowerCase"),
      type: "date",
      valueGetter: (data: GridRenderCellParams<Row>, row) => (row.startTime === null ? null : new Date(row.startTime)),
      minWidth: CellSize.small,
      flex: CellSize.small,
      renderCell: (data: GridRenderCellParams<Row>) =>
        data.value === null ? (
          <Typography variant="body2" color="text.tier">
            {t("common:notStarted")}
          </Typography>
        ) : (
          <TableCellDateTime data={{ value: data?.row?.startTime }} />
        ),
    },
    {
      field: "endTime",
      headerName: t("common:endDateLowerCase"),
      type: "date",
      valueGetter: (data: GridRenderCellParams<Row>, row) => (row.endTime === null ? null : new Date(row.endTime)),
      minWidth: CellSize.small,
      flex: CellSize.small,
      renderCell: (data: GridRenderCellParams<Row>) =>
        data.value === null ? (
          <Typography variant="body2" color="text.tier">
            {t("common:notFinished")}
          </Typography>
        ) : (
          <TableCellDateTime data={{ value: data?.row?.endTime }} />
        ),
    },
    {
      field: "dueDate",
      headerName: t("common:dueDate"),
      type: "date",
      valueGetter: (data: GridRenderCellParams<Row>, row) => (row.dueDate === null ? null : new Date(row.dueDate)),
      minWidth: CellSize.small,
      flex: CellSize.small,
      renderCell: (data: GridRenderCellParams<Row>) =>
        data?.row?.status !== OrderStatus.COMPLETED && data?.row?.dueDate ? (
          <TableCellDueDate data={{ value: data?.row?.dueDate }} />
        ) : (
          <></>
        ),
    },
    {
      field: "actions",
      headerName: "",
      type: "actions",
      align: "right",
      minWidth: context !== OrderItemTableContext.Quotes ? CellSize.actionsSmall : CellSize.actionsDefault,
      flex: context !== OrderItemTableContext.Quotes ? CellSize.actionsSmall : CellSize.actionsDefault,
      getActions: (params: GridRowParams) => {
        if (!params || !params.row) return [];
        let activities = params?.row?.activities ? params?.row?.activities.length : 0;

        let array: any[] = [];

        {
          activities > 0 &&
            array.push(
              <Chip
                onClick={() => handleShowPanelOrder(params.row)}
                label={activities}
                color={"default"}
                icon={<ChatOutlinedIcon />}
              />
            );
        }

        let play =
          (((params?.row?.status === OrderStatus.READY || params?.row?.status === OrderStatus.SCHEDULED) && aclStart) ||
            (params?.row?.status === OrderStatus.WAITING_APPROVAL && aclApprove) ||
            (params?.row?.status === OrderStatus.CREATED &&
              (params?.row?.stack === null || params?.row?.stack?.tasks?.length === 0)) ||
            params?.row?.status === OrderStatus.QUOTE_ACCEPTED) &&
          params?.row?.doable &&
          !isCockpit;
        let cancel =
          (params.row.status === OrderStatus.READY ||
            params.row.status === OrderStatus.CREATED ||
            params.row.status === OrderStatus.QUEUED ||
            params.row.status === OrderStatus.RUNNING ||
            params.row.status === OrderStatus.ABORTED ||
            params.row.status === OrderStatus.SCHEDULED ||
            params.row.status === OrderStatus.QUOTE_PROPOSED ||
            params.row.status === OrderStatus.QUOTE_REQUESTED ||
            params.row.status === OrderStatus.QUOTE_DECLINED ||
            params.row.status === OrderStatus.FAILED) &&
          params.row.isAutomatedPipeline &&
          aclCancel;
        let retry =
          aclStart &&
          (aclAdmin || aclSuperUser) &&
          (params.row.status === OrderStatus.ABORTED || params.row.status === OrderStatus.FAILED) &&
          params.row.isAutomatedPipeline;
        let retryScratch =
          (aclAdmin || aclSuperUser) &&
          (params.row.status === OrderStatus.ABORTED ||
            params.row.status === OrderStatus.FAILED ||
            params.row.status === OrderStatus.CANCELED ||
            params.row.status === OrderStatus.COMPLETED) &&
          params.row.isAutomatedPipeline;
        let modify =
          aclModify &&
          (params.row.status === OrderStatus.READY ||
            params.row.status === OrderStatus.QUOTE_REQUESTED ||
            params.row.status === OrderStatus.QUOTE_PROPOSED ||
            params.row.status === OrderStatus.QUOTE_DECLINED) &&
          !isCockpit;
        let priority =
          aclPriority &&
          (params.row.status === OrderStatus.READY ||
            params.row.status === OrderStatus.QUEUED ||
            params.row.status === OrderStatus.CREATED) &&
          !isCockpit;

        let copy = aclCopy && params?.row?.status === OrderStatus.COMPLETED && !isCockpit;
        let processingMode: ItemProcessingMode = getItemProcessingMode(params.row);
        let setManualStatus =
          (processingMode === ItemProcessingMode.Manual && aclSuperUser) ||
          (processingMode === ItemProcessingMode.ManualExternal && aclOrderManualTaskExternalChangeStatus) ||
          (params?.row?.isAutomatedPipeline && params?.row?.type === OrderProductType.ManualTasks && !isCockpit);
        let setFollowers = aclOrderAssignFollowers && !isCockpit;

        if (!isCockpit)
          array.push(
            <GridActionsCellItem
              icon={<InfoIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:infos")}
              onClick={() => {
                if (showPanelOrder) showPanelOrder(params?.row?.id);
              }}
              showInMenu
            />
          );

        // Quote workflow
        if (
          aclQuoteValidate &&
          context === OrderItemTableContext.Quotes &&
          params?.row?.status === OrderStatus.QUOTE_PROPOSED
        ) {
          array.push(
            <GridActionsCellItem
              icon={
                <Tooltip title={t("tooltip:title.acceptTheOffer")}>
                  <ThumbUpIcon sx={{ width: 20, height: 20, color: "text.success" }} />
                </Tooltip>
              }
              label={t("common:accept")}
              color="success"
              onClick={() => handleAcceptOrDeclineQuote(true, params?.row?.id)}
            />
          );
          array.push(
            <GridActionsCellItem
              icon={
                <Tooltip title={t("tooltip:title.declineTheOffer")}>
                  <ThumbDownIcon sx={{ width: 20, height: 20, color: "text.warning" }} />
                </Tooltip>
              }
              label={t("common:decline")}
              color="warning"
              onClick={() => handleAcceptOrDeclineQuote(false, params?.row?.id)}
            />
          );
        }

        // Normal behaviors
        if (play)
          array.push(
            <GridActionsCellItem
              icon={<PlayCircleIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:play")}
              onClick={() => {
                orderService.PlayOrderItemById(params?.row?.id).then((response) => {
                  if (response.success) enqueueCustomSnackbar(t("alert:success.itemPlayed"), "success");
                  else
                    enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
                });
              }}
              showInMenu
            />
          );
        if (cancel)
          array.push(
            <GridActionsCellItem
              icon={<CancelIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:cancel")}
              onClick={() => {
                isCockpit
                  ? cockpitService
                      .MakeAdminOperation(
                        new MakeOperationRequest({
                          resourceId: params?.row?.id,
                          resourceType: ResourceType.OrderItem,
                          action: Action.Cancel,
                        })
                      )
                      .then((response) => {
                        if (response.success) {
                          dispatch(CancelOrdersByIds([params?.row?.id]));
                          enqueueCustomSnackbar(t("alert:success.itemCanceled"), "success");
                        } else
                          enqueueCustomSnackbar(
                            t("alert:error.oopsWithMessage", { message: response.message }),
                            "warning"
                          );
                      })
                  : orderService.CancelOrderItemById(params?.row?.id).then((response) => {
                      if (response.success) {
                        enqueueCustomSnackbar(t("alert:success.itemCanceled"), "success");
                        dispatch(CancelOrdersByIds([params?.row?.id]));
                      } else
                        enqueueCustomSnackbar(
                          t("alert:error.oopsWithMessage", { message: response.message }),
                          "warning"
                        );
                    });
              }}
              showInMenu
            />
          );
        if (retry)
          array.push(
            <GridActionsCellItem
              icon={<ReplayIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:retry")}
              onClick={() => {
                isCockpit
                  ? cockpitService
                      .MakeAdminOperation(
                        new MakeOperationRequest({
                          resourceId: params?.row?.id,
                          resourceType: ResourceType.OrderItem,
                          action: Action.Retry,
                        })
                      )
                      .then((response) => {
                        if (response.success) enqueueCustomSnackbar(t("alert:success.itemRetried"), "success");
                        else
                          enqueueCustomSnackbar(
                            t("alert:error.oopsWithMessage", { message: response.message }),
                            "warning"
                          );
                      })
                  : orderService.RetryOrderItemById(params?.row?.id).then((response) => {
                      if (response.success) enqueueCustomSnackbar(t("alert:success.itemRetried"), "success");
                      else
                        enqueueCustomSnackbar(
                          t("alert:error.oopsWithMessage", { message: response.message }),
                          "warning"
                        );
                    });
              }}
              showInMenu
            />
          );
        if (retryScratch)
          array.push(
            <GridActionsCellItem
              icon={<ReplayIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:retryFromScratch")}
              onClick={() => {
                isCockpit
                  ? cockpitService
                      .MakeAdminOperation(
                        new MakeOperationRequest({
                          resourceId: params?.row?.id,
                          resourceType: ResourceType.OrderItem,
                          action: Action.RetryFromScratch,
                        })
                      )
                      .then((response) => {
                        if (response.success) enqueueCustomSnackbar(t("alert:success.itemRetried"), "success");
                        else
                          enqueueCustomSnackbar(
                            t("alert:error.oopsWithMessage", { message: response.message }),
                            "warning"
                          );
                      })
                  : orderService.RetryFromScratchOrderItemById(params?.row?.id).then((response) => {
                      if (response.success) enqueueCustomSnackbar(t("alert:success.itemRetriedFromScratch"), "success");
                      else
                        enqueueCustomSnackbar(
                          t("alert:error.oopsWithMessage", { message: response.message }),
                          "warning"
                        );
                    });
              }}
              showInMenu
            />
          );
        if (setFollowers)
          array.push(
            <GridActionsCellItem
              icon={<GroupsOutlinedIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:setFollowers")}
              onClick={() => {
                openModal &&
                  openModal<ModalSetFollowersElementProps>(ModalSetFollowers, {
                    objectIds: [params?.row?.id],
                    objectType: "orderItem",
                    currentFollowersIds: params?.row?.followerUserIds,
                  });
              }}
              showInMenu
            />
          );
        if (
          modify &&
          (params?.row?.status === OrderStatus.READY ||
            ((aclSuperUser || aclAdmin) &&
              (params?.row?.status === OrderStatus.QUOTE_REQUESTED ||
                params?.row?.status === OrderStatus.QUOTE_PROPOSED ||
                params?.row?.status === OrderStatus.QUOTE_DECLINED)))
        )
          array.push(
            <GridActionsCellItem
              icon={<EditIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:modify")}
              onClick={() => modifyObjectByIdToBasket(params?.row?.id)}
              showInMenu
            />
          );
        if (copy)
          array.push(
            <GridActionsCellItem
              icon={<ShoppingBagOutlinedIcon />}
              label={t("table:cellLabel.makeNewOrder")}
              onClick={() => copyObjectByIdToBasket(params?.row?.id)}
              showInMenu
            />
          );
        if (setManualStatus)
          array.push(
            <GridActionsCellItem
              icon={<AutoFixHighIcon sx={{ width: 20, height: 20, color: "text.primary" }} />}
              label={t("common:applyManualChanges")}
              onClick={() => handleManualChanges(params.row)}
              showInMenu
            />
          );
        if (priority) {
          if (params?.row?.priority !== 10)
            array.push(
              <GridActionsCellItem
                icon={<PriorityHighIcon />}
                label={t("table:cellLabel.setPriorityUrgent")}
                onClick={() => handleSetPriority(params?.row?.id, 10)}
                showInMenu
              />
            );
          if (params?.row?.priority !== 9)
            array.push(
              <GridActionsCellItem
                icon={<ArrowUpwardIcon />}
                label={t("table:cellLabel.setPriorityHigh")}
                onClick={() => handleSetPriority(params?.row?.id, 9)}
                showInMenu
              />
            );
          if (params?.row?.priority !== 5)
            array.push(
              <GridActionsCellItem
                icon={<ArrowForwardIcon />}
                label={t("table:cellLabel.setPriorityNormal")}
                onClick={() => handleSetPriority(params?.row?.id, 5)}
                showInMenu
              />
            );
          if (params?.row?.priority !== 2)
            array.push(
              <GridActionsCellItem
                icon={<ArrowDownwardIcon />}
                label={t("table:cellLabel.setPriorityLow")}
                onClick={() => handleSetPriority(params?.row?.id, 2)}
                showInMenu
              />
            );
        }
        if (
          (params?.row?.status === OrderStatus.FAILED || params?.row?.status === OrderStatus.ABORTED) &&
          UserHasAcl(AclTypes.aclSupportTicketCreate)
        ) {
          let platformSettings = cacheService.GetPlatformSettings();
          array.push(
            <TableCellActionReportIssue
              text={`
                ${t("common:platform")}: ${platformSettings?.name}\n
                ${t("table:body.upperCaseOrderIdColumnName")}: ${params?.row?.orderId}\n
                ${t("table:body.itemIdColumnName")}: ${params?.row?.id}\n
                ${t("common:lowerCaseStatus")}: ${params?.row?.status}\n
                ${t("common:lowerCaseMessage")}: ${params?.row?.message}
              `}
              typology="Order"
              objectId={params?.row?.orderId}
              showInMenu
              {...params}
            />
          );
        }
        return array;
      },
    },
  ];

  // Trig open panel
  const handleShowPanelOrder = (e: any) => {
    if (showPanelOrder) showPanelOrder(e.id);
  };

  // Get counters by status
  const getCounter = (rows: any, statuses: OrderStatus[]): number => {
    return rows.filter((x: any) => statuses.map((s) => s.toString()).find((f) => f === x.status) !== undefined).length;
  };

  // Quick filter on table grid
  const changeQuickFilter = (statuses: OrderStatus[], index: number) => {
    // On reclic => remove filter
    if (filterIndex === index) {
      setFilterIndexStatus([]);
      setFilterIndex(-1);
      return;
    }

    // Apply filter on table
    setFilterIndexStatus(statuses);
    setFilterIndex(index);
  };

  // Export XSL
  const exportExcel = () => {
    apiGrid.current.exportDataAsCsv({ delimiter: GlobalConst.EXPORT_DELIMITER, allColumns: true });
  };

  // Filter
  const handleFilterPlatform = (event: SelectChangeEvent<number>) => {
    setFilterPlatform(event.target.value as number);
  };

  const handleFilterCustomer = (event: SelectChangeEvent<number>) => {
    setFilterCustomer(event.target.value as number);
  };

  const handleFilterStatus = (event: SelectChangeEvent<string>) => {
    setFilterStatus(event.target.value);
  };

  const handleFilterType = (event: SelectChangeEvent<string>) => {
    setFilterType(event.target.value === "" ? undefined : (event.target.value as OrderProductType));
  };

  const handleFilterUserGroup = (event: SelectChangeEvent<string>) => {
    setFilterUserGroup(event.target.value);
  };

  const handleFilterEditor = (event: SelectChangeEvent<string>) => {
    setFilterEditor(event.target.value);
  };

  const handleFilterProcessingMode = (event: SelectChangeEvent<ItemProcessingMode>) => {
    if (event.target.value === "") setFilterProcessingMode(undefined);
    else setFilterProcessingMode(event.target.value as ItemProcessingMode);
  };

  const handleFilterFlag = (event: SelectChangeEvent<OrderItemProductNonDoableFlag | "">) => {
    if (event.target.value === "") setFilterFlag(undefined);
    else setFilterFlag(event.target.value as OrderItemProductNonDoableFlag);
  };

  const handleFilterWatermark = (event: SelectChangeEvent<string>) => {
    setFilterWatermark(event.target.value);
  };

  const handleFilterWarning = (event: SelectChangeEvent<string>) => {
    setFilterWarning(event.target.value);
  };

  const handleFilterPriority = (e) => {
    setFilterPriority(e.target.value);
  };

  const handleFilterUnsetAll = () => {
    setFilterCustomer(-1);
    setFilterPlatform(-1);
    setFilterStatus("");
    setFilterCustomer(-1);
    setFilterText("");
    setFilterIndexStatus([]);
    setFilterIndex(-1);
  };

  // Actions
  const handleSetPriority = (itemId: number, priority: number) => {
    orderService.SetPriorityOnOrderItemById(itemId, priority).then((response) => {
      enqueueCustomSnackbar(t("alert:success.itemPriorityChanged"), "success");
    });
  };

  const handleManualChanges = (item: DbOrderItemInfos) => {
    openModal &&
      openModal<ModalOrderManualChangesProps>(ModalOrderManualChanges, {
        closeModal: () => false,
        items: [item],
      });
  };

  const handleAcceptOrDeclineQuote = (accept: boolean, id: number) => {
    if (accept) {
      orderService
        .ApplyManualChangesOnItemById({
          itemId: id,
          status: OrderStatus.QUOTE_ACCEPTED,
          message: t("alert:success.userHasAcceptedQuote"),
          doable: true,
          nonDoableFlag: null,
        })
        .then((response) => {
          if (response.success)
            orderService.PlayOrderItemById(id).then((response) => {
              if (response.success) enqueueCustomSnackbar(t("alert:success.quoteAcceptedAndPlayed"), "success");
              else enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
            });
        });
    } else {
      if (!openModal) return;

      openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
        displayComment: true,
        commentLabel: t("modal:body.letUsMessageToExplainYourDecline"),
        title: t("modal:title.declineQuoteProposal"),
        onConfirm: (comment) => {
          orderService
            .ApplyManualChangesOnItemById({
              itemId: id,
              status: OrderStatus.QUOTE_DECLINED,
              message: comment ?? t("modal:message.userHasDeclinedOffer"),
              doable: true,
              nonDoableFlag: null,
            })
            .then((response) => {
              if (response.success) enqueueCustomSnackbar(t("alert:success.quoteDeclined"), "success");
              else enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
            });
        },
      });
    }
  };

  const getPriority = (priority: number) => {
    if (priority > 0 && priority <= 5) {
      return "Normal";
    } else if (priority < 5) {
      return "Low";
    } else if (priority > 5 && priority <= 9) {
      return "High";
    } else if (priority >= 10) {
      return "Urgent";
    } else {
      return "Normal";
    }
  };

  const filteredRows = React.useMemo(() => {
    const output = rows.filter(
      (x) =>
        (filterIndexStatuses.length === 0 || filterIndexStatuses.includes(x.status!)) &&
        (filterCustomer === -1 || x.customerId === filterCustomer) &&
        (filterPlatform === -1 || x.platformId === filterPlatform) &&
        (filterStatus === "" || x.status === filterStatus) &&
        (!filterProcessingMode || getItemProcessingMode(x) === filterProcessingMode) &&
        (!filterFlag ||
          (filterFlag !== OrderItemProductNonDoableFlag.Unknown && x.nonDoableFlag === filterFlag) ||
          (filterFlag === OrderItemProductNonDoableFlag.Unknown && x.nonDoableFlag === null)) &&
        (!filterType || x.type === filterType) &&
        (filterUserGroup === "" || x.ownerUserGroupName === filterUserGroup) &&
        (filterEditor === "" || x.editorName === filterEditor) &&
        (filterWatermark === "" || x.watermarking.toString() === filterWatermark) &&
        (filterWarning === "" ||
          (filterWarning === "true" && x.warningDetails !== null && x.warningDetails.length > 0) ||
          (filterWarning === "false" && (x.warningDetails === null || x.warningDetails.length === 0))) &&
        (!filterPriority || filterPriority === "" || getPriority(x.priority ?? 0) === filterPriority)
    );

    onFilteredItemCountChange && onFilteredItemCountChange(output.length);

    return output;
  }, [
    rows,
    filterIndexStatuses,
    filterCustomer,
    filterPlatform,
    filterStatus,
    filterText,
    filterProcessingMode,
    filterFlag,
    filterType,
    filterUserGroup,
    filterEditor,
    filterWatermark,
    filterWarning,
    filterPriority,
  ]);

  // Map data
  React.useEffect(() => {
    if (!orders) return;
    setDataGrid(orders);

    let distinctCustomers = [
      ...new Map(
        orders
          .filter((x) => x.customer !== null)
          .map((x) => x.customer)
          .sort((a, b) => a!.name!.localeCompare(b!.name!))
          .map((item) => [item!["id"], item!])
      ).values(),
    ];

    setCustomers(distinctCustomers);
  }, [orders]);

  // Memo
  const productTypes: OrderProductType[] = useMemo(() => {
    return orders.map((item) => item.type).filter(Distinct);
  }, [orders]);

  const additionalFilters = (
    <>
      {isCockpit && (
        <>
          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            value={filterPlatform}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            startAdornment={<PlaceIcon />}
            onChange={(value) => handleFilterPlatform(value)}
          >
            <MenuItem value={-1}>{t("common:platform")}</MenuItem>
            {platforms!.map((platform, index) => (
              <MenuItem value={platform.id!} key={index}>
                {platform.name}
              </MenuItem>
            ))}
          </Select>
          <Select
            displayEmpty
            startAdornment={<PriorityHighIcon />}
            IconComponent={ExpandMoreRoundedIcon}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            value={filterPriority}
            onChange={handleFilterPriority}
          >
            <MenuItem value={undefined}>{t("common:priority")}</MenuItem>
            {["Normal", "Low", "High", "Urgent"].map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </>
      )}
      {context !== OrderItemTableContext.Quotes && (
        <>
          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            value={filterCustomer}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            startAdornment={<HandshakeOutlinedIcon />}
            onChange={(value) => handleFilterCustomer(value)}
          >
            <MenuItem value={-1}>{t("common:customer")}</MenuItem>
            {customers.map((customer, index) => (
              <MenuItem value={customer.id} key={index}>
                {customer.name}
              </MenuItem>
            ))}
          </Select>
          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            value={filterStatus}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            startAdornment={<BarChartOutlinedIcon />}
            onChange={(value) => handleFilterStatus(value)}
          >
            <MenuItem value="" key="">
              {t("common:status")}
            </MenuItem>
            <MenuItem value="READY" key="READY">
              {t("common:ready")}
            </MenuItem>
            <MenuItem value="CREATED" key="CREATED">
              {t("common:created")}
            </MenuItem>
            <MenuItem value="QUEUED" key="QUEUED">
              {t("common:pending")}
            </MenuItem>
            <MenuItem value="RUNNING" key="RUNNING">
              {t("common:processing")}
            </MenuItem>
            <MenuItem value="MANUAL_DELIVERY_BEFORE_COMPLETED" key="MANUAL_DELIVERY_BEFORE_COMPLETED">
              {t("common:manualDelivery")}
            </MenuItem>
            <MenuItem value="COMPLETED" key="COMPLETED">
              {t("common:delivered")}
            </MenuItem>
            <MenuItem value="FAILED" key="FAILED">
              {t("common:fixing")}
            </MenuItem>
            <MenuItem value="ABORTED" key="ABORTED">
              {t("common:aborted")}
            </MenuItem>
            <MenuItem value="CANCELED" key="CANCELED">
              {t("common:canceled")}
            </MenuItem>
            <MenuItem value="STANDBY" key="STANDBY">
              {t("common:standby")}
            </MenuItem>
            <MenuItem value="SCHEDULED" key="SCHEDULED">
              {t("common:scheduled")}
            </MenuItem>
          </Select>
          <Select
            displayEmpty
            startAdornment={<WorkspacesOutlined />}
            IconComponent={ExpandMoreRoundedIcon}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            value={filterType}
            onChange={handleFilterType}
          >
            <MenuItem value={undefined}>{t("common:type")}</MenuItem>
            {productTypes.map((type) => (
              <MenuItem key={type} value={OrderProductType[type]}>
                {GetOrderProductReadableType(OrderProductType[type])}
              </MenuItem>
            ))}
          </Select>
          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            startAdornment={<MemoryIcon />}
            value={filterProcessingMode}
            onChange={(value) => handleFilterProcessingMode(value)}
          >
            <MenuItem value={undefined} key="">
              {t("menu:item.processingMode")}
            </MenuItem>
            <MenuItem value={ItemProcessingMode.Auto} key="Auto">
              {t("common:auto")}
            </MenuItem>
            <MenuItem value={ItemProcessingMode.Hybrid} key="Hybrid">
              {t("common:hybrid")}
            </MenuItem>
            <MenuItem value={ItemProcessingMode.Manual} key="ManualInt">
              {t("menu:item.manualMadeInternally")}
            </MenuItem>
            <MenuItem value={ItemProcessingMode.ManualExternal} key="ManualExt">
              {t("menu:item.manualMadeExternally")}
            </MenuItem>
          </Select>

          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            startAdornment={<CheckOutlined />}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            value={filterFlag}
            onChange={(value) => handleFilterFlag(value)}
          >
            <MenuItem value={undefined} key="">
              {t("common:doability")}
            </MenuItem>
            <MenuItem value={OrderItemProductNonDoableFlag.Unknown} key="Unknown">
              {t("menu:item.doableOk")}
            </MenuItem>
            <MenuItem value={OrderItemProductNonDoableFlag.MissingAssets} key="Missing">
              {t("menu:item.missingAssets")}
            </MenuItem>
            <MenuItem value={OrderItemProductNonDoableFlag.CandidateAssets} key="Candidate">
              {t("menu:item.candidateAssets")}
            </MenuItem>
          </Select>
          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            startAdornment={<SecurityIcon />}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            value={filterWatermark}
            onChange={(value) => handleFilterWatermark(value)}
          >
            <MenuItem value="" key="">
              {t("common:watermark")}
            </MenuItem>
            <MenuItem value={"true"} key="WmEnabled">
              {t("common:enabled")}
            </MenuItem>
            <MenuItem value={"false"} key="WmDisabled">
              {t("common:disabled")}
            </MenuItem>
          </Select>
          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            startAdornment={<WarningIcon />}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            value={filterWarning}
            onChange={(value) => handleFilterWarning(value)}
          >
            <MenuItem value="" key="">
              {t("common:warning")}
            </MenuItem>
            <MenuItem value={"true"} key="WmEnabled">
              {t("menu:item.withWarning")}
            </MenuItem>
            <MenuItem value={"false"} key="WmDisabled">
              {t("menu:item.withoutWarning")}
            </MenuItem>
          </Select>
        </>
      )}
      {context === OrderItemTableContext.Quotes && (
        <>
          <Select
            displayEmpty
            IconComponent={ExpandMoreRoundedIcon}
            value={filterStatus}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            startAdornment={<BarChartOutlinedIcon />}
            onChange={(value) => handleFilterStatus(value)}
          >
            <MenuItem value="" key="">
              {t("common:status")}
            </MenuItem>
            <MenuItem value="QUOTE_REQUESTED" key="QUOTE_REQUESTED">
              {t("common:quoteRequested")}
            </MenuItem>
            <MenuItem value="QUOTE_PROPOSED" key="QUOTE_PROPOSED">
              {t("common:quoteProposed")}
            </MenuItem>
            <MenuItem value="QUOTE_ACCEPTED" key="QUOTE_ACCEPTED">
              {t("common:quoteAccepted")}
            </MenuItem>
            <MenuItem value="QUOTE_DECLINED" key="QUOTE_DECLINED">
              {t("common:quoteDeclined")}
            </MenuItem>
          </Select>
          <Select
            displayEmpty
            startAdornment={<AccountCircleIcon />}
            IconComponent={ExpandMoreRoundedIcon}
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
            value={filterEditor}
            onChange={handleFilterEditor}
          >
            <MenuItem value="">{t("common:proposedBy")}</MenuItem>
            {rows
              .map((x) => x.editorName)
              .filter((x) => x !== null && x !== "")
              .filter(Distinct)
              .sort((a, b) => a!.localeCompare(b!))
              .map((editor) => (
                <MenuItem key={editor!} value={editor!}>
                  {editor}
                </MenuItem>
              ))}
          </Select>
        </>
      )}

      <Select
        displayEmpty
        startAdornment={<AccountCircleIcon />}
        IconComponent={ExpandMoreRoundedIcon}
        inputProps={{ "aria-label": "Without label" }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
        value={filterUserGroup}
        onChange={handleFilterUserGroup}
      >
        <MenuItem value="">{t("common:group")}</MenuItem>
        {rows
          .map((x) => x.ownerUserGroupName)
          .filter(Distinct)
          .sort((a, b) => a!.localeCompare(b!))
          .map((group) => (
            <MenuItem key={group!} value={group!}>
              {group}
            </MenuItem>
          ))}
      </Select>
    </>
  );

  return (
    <>
      {!isCockpit && (
        <Grid2 container spacing={1} sx={{ py: 2 }}>
          <Grid2 size={context !== OrderItemTableContext.Quotes ? 2 : 3}>
            <PageFilter
              variant="background"
              title={rows.length}
              subtitle={t("common:total")}
              icon={<EventNoteIcon />}
              active={filterIndex === 0}
              onClick={() => handleFilterUnsetAll()}
              isLoading={isLoading}
            />
          </Grid2>
          {context !== OrderItemTableContext.Quotes && (
            <>
              <Grid2 size={2}>
                <PageFilter
                  variant="primary"
                  title={getCounter(rows, [OrderStatus.RUNNING])}
                  subtitle={t("common:processing")}
                  icon={<CachedIcon />}
                  active={filterIndex === 1}
                  onClick={() => changeQuickFilter([OrderStatus.RUNNING], 1)}
                  isLoading={isLoading}
                />
              </Grid2>
              <Grid2 size={2}>
                <PageFilter
                  title={getCounter(rows, [OrderStatus.COMPLETED])}
                  subtitle={t("common:delivered")}
                  icon={<CheckIcon />}
                  active={filterIndex === 2}
                  onClick={() => changeQuickFilter([OrderStatus.COMPLETED], 2)}
                  isLoading={isLoading}
                />
              </Grid2>
              <Grid2 size={2}>
                <PageFilter
                  variant="background"
                  title={getCounter(rows, [OrderStatus.QUEUED])}
                  subtitle={t("common:pending")}
                  icon={<HourglassEmptyIcon />}
                  active={filterIndex === 3}
                  onClick={() => changeQuickFilter([OrderStatus.QUEUED], 3)}
                  isLoading={isLoading}
                />
              </Grid2>
              <Grid2 size={2}>
                <PageFilter
                  variant="info"
                  title={getCounter(rows, [OrderStatus.MANUAL_DELIVERY_BEFORE_COMPLETED])}
                  subtitle={t("common:manualDelivery")}
                  icon={<AirportShuttleIcon />}
                  active={filterIndex === 4}
                  onClick={() => changeQuickFilter([OrderStatus.MANUAL_DELIVERY_BEFORE_COMPLETED], 4)}
                  isLoading={isLoading}
                />
              </Grid2>
              <Grid2 size={2}>
                <PageFilter
                  variant="warning"
                  title={getCounter(rows, [OrderStatus.FAILED, OrderStatus.ABORTED])}
                  subtitle={t("common:fixingUp")}
                  icon={<SettingsOutlinedIcon />}
                  active={filterIndex === 5}
                  onClick={() => changeQuickFilter([OrderStatus.FAILED, OrderStatus.ABORTED], 5)}
                  isLoading={isLoading}
                />
              </Grid2>
            </>
          )}
          {context === OrderItemTableContext.Quotes && (
            <>
              <Grid2 size={3}>
                <PageFilter
                  title={getCounter(rows, [OrderStatus.QUOTE_REQUESTED])}
                  subtitle={t("common:quoteRequested")}
                  icon={<EmojiPeopleIcon />}
                  active={filterIndex === 2}
                  variant="primary"
                  onClick={() => changeQuickFilter([OrderStatus.QUOTE_REQUESTED], 2)}
                  isLoading={isLoading}
                />
              </Grid2>
              <Grid2 size={3}>
                <PageFilter
                  variant="info"
                  title={getCounter(rows, [OrderStatus.QUOTE_PROPOSED])}
                  subtitle={t("common:quoteProposed")}
                  icon={<HelpIcon />}
                  active={filterIndex === 3}
                  onClick={() => changeQuickFilter([OrderStatus.QUOTE_PROPOSED], 3)}
                  isLoading={isLoading}
                />
              </Grid2>
              <Grid2 size={3}>
                <PageFilter
                  variant="warning"
                  title={getCounter(rows, [OrderStatus.QUOTE_DECLINED])}
                  subtitle={t("common:quoteDeclined")}
                  icon={<ThumbDownAltIcon />}
                  active={filterIndex === 4}
                  onClick={() => changeQuickFilter([OrderStatus.QUOTE_DECLINED], 4)}
                  isLoading={isLoading}
                />
              </Grid2>
            </>
          )}
        </Grid2>
      )}

      <DataTable
        loading={isLoading}
        tableKey={TableUuids.ORDER_ITEMS_TABLE}
        selectedRows={selectedItems?.map((x) => x.id)}
        setSelectedRows={(e) =>
          setSelectedItems && setSelectedItems(rows.filter((x) => (e as number[]).includes(x.id)))
        }
        rows={filteredRows}
        columns={columns}
        checkboxSelection={!isCockpit}
        disableRowSelectionOnClick
        onRowClick={handleShowPanelOrder}
        pagination={true}
        additionalFilters={additionalFilters}
        apiRef={apiGrid}
        getRowHeight={() => "auto"}
        initialColumnVisibility={{
          platformId: platforms && platforms.length > 0 ? true : false,
          titleCustomerId: customerName !== "" && context === OrderItemTableContext.Search,
          price: context === OrderItemTableContext.Quotes,
          editorName: context === OrderItemTableContext.Quotes,
          type: context !== OrderItemTableContext.Quotes,
          customerName: false,
          dueDate: false,
          startTime: context === OrderItemTableContext.Search,
          endTime: context === OrderItemTableContext.Search,
          itemId: false,
          ownerUserName: true,
        }}
      />
    </>
  );
};

export default OrderItemTable;
